export enum rdeDevicebrandEnum {
    Diebold = 1,
    Schlumberger = 2,
    XAC = 3,
    Nokia = 4,
    Demoa = 5,
    PAX = 6
}

export namespace rdeDevicebrandEnum {
    export function values() {
        return Object.keys(rdeDevicebrandEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
